<section class="section" style="max-height: 50%"
  [ngStyle]="backGroundImageStyle()"
  [ngClass]="imageUrl.length > 0 ? ['site-hero', 'overlay'] : ''">
  <div class="container">
    <ng-content select="[header]"></ng-content>
    <ng-content select="[section-content]"></ng-content>
    <ng-content select="[footer]"></ng-content>
  </div>
</section>
